// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import segEntity from './entities/seg.json';
import segMenu from '../pages/seg/menu.json';
import segFullForm from '../pages/seg/forms/full.json';
import segContextForm from '../pages/seg/forms/context.json';
import segMiniForm from '../pages/seg/forms/mini.json';
import segLookupForm from '../pages/seg/forms/lookup.json';
import segTableView from '../pages/seg/views/table.json';
import segStagesView from '../pages/seg/views/stages.json';
import segCardsView from '../pages/seg/views/cards.json';
import segInlineView from '../pages/seg/views/inline.json';
import segBacklogView from '../pages/seg/views/backlog.json';
import segSplitView from '../pages/seg/views/split.json';
import segCalendarView from '../pages/seg/views/calendar.json';
import segDashboardView from '../pages/seg/views/dashboard.json';

/** Тип запису «Сегмент» зі сторінками пакета: меню, форми та подання з pages/seg/. */
export const segDefinition: IRecordTypeDefinition = {
  ...segEntity,
  views: assembleViewSet({
      table: segTableView,
      stages: segStagesView,
      cards: segCardsView,
      inline: segInlineView,
      backlog: segBacklogView,
      split: segSplitView,
      calendar: segCalendarView,
      dashboard: segDashboardView,
  }),
  form: segFullForm,
  forms: { full: segFullForm, context: segContextForm, mini: segMiniForm, lookup: segLookupForm },
  menu: segMenu,
} as IRecordTypeDefinition;
